var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1123 51.5294L59.7855 73.9664L18.0039 50.0672L16.0501 51.1261V68.4706L59.8356 93.5798L99.1624 71.1429V80.3698L59.8356 102.807L18.0039 78.9076L16.0501 79.9664V82.8908L59.8356 108L103.771 82.8908V65.5462L101.818 64.4874L59.7855 88.3866L20.609 65.9496V56.874L59.7855 79.1597L103.721 54.0504V36.958L101.467 35.7479L59.7855 59.4958L22.7131 38.2689L59.7855 17.1933L90.3953 34.5378L93.1507 33.0756V30.958L59.7855 12L16 37.0084V39.6807L59.7855 64.7899L99.1123 42.3529V51.5294Z",
    fill: "#FF3621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.4fdcfde1f576502fbc434881561124a6.svg";
export { ForwardRef as ReactComponent };